import React from "react";
import IntOutBoundFileList from "../component/intOutBoundFileList";

const IntOutBoundFileListContainer = ({ pageId }) => (<IntOutBoundFileList pageId = {pageId}/>)

export default IntOutBoundFileListContainer;